/**
 * SanCanDo Quote Cart helpers
 * 2026-09-18: prefill Request a Quote from /cart.js, clear cart after submit, mailto fallback.
 * 2026-09-24 Quote intake P1: structured, labeled contact[...] fields per cart line;
 *   per-item Decoration method select filtered by product locks; clean contact[body].
 * Loaded once, deferred, from layout/theme.liquid. Light boot: does nothing unless a
 * [data-sancando-request-quote] form is on the page (plus a sessionStorage check).
 * No prices are read or written.
 * 2026-10-02 (Jefe) two-lane cart: lines the Liquid map marks 'journal_public' (public-price journals) are left OUT of
 *   the quote. After a successful send only the quote lines are removed (/cart/update.js, line keys saved before submit);
 *   the journals stay in the cart to check out. No more /cart/clear.js.
 *   2026-10-02 23:5x (El Jefe gate fix 5): success page with no saved keys -> remove ALL quote lines (live parity).
 * 2026-10-07 (#167 only until El Jefe PASS): public price now also covers non-RTIC drinkware + glassware (Liquid predicate).
 *   - Fee lines (line property _addon, e.g. Second-side engraving) follow their PARENT line: parent = line whose product id
 *     equals the fee's _parent property, else (older fee lines) the line whose product title equals the fee's For property.
 *     A fee with a public parent stays in the buy lane: never in the quote, never removed by a quote send.
 *     Mirrors snippets/sancando-line-public.liquid. Fees with a CFP parent / no parent behave exactly as before.
 *   - Stale map fix: when a cart product is missing from the Liquid map (cart changed after page load), the map is
 *     re-fetched once from the cart section (/cart?sections=sancando-request-quote) before classifying.
 *   - Copy: "Your items are still in your cart".
 */
(function () {
  'use strict';
  if (window.__sancandoQuoteCart) return;
  window.__sancandoQuoteCart = true;

  var STORAGE_CLEAR = 'sancando_quote_clear_cart'; /* value: JSON array of quote line keys (legacy '1' = all quote lines) */
  var PUBLIC_CLASS = 'journal_public';

  /* Placeholder method list (pending Jefe confirmation). */
  var ALL_METHODS = ['Laser engraving', 'Sandblasting', 'Full-color UV', 'Embroidery', 'DTF print', 'Leatherette patch', 'Not sure'];
  /* Product locks: no Full-color UV on glassware / silicone-grip / handled; Embroidery only collared + hats. */
  var METHODS_BY_CLASS = {
    drink: ['Laser engraving', 'Full-color UV', 'Not sure'],
    drink_nouv: ['Laser engraving', 'Not sure'],
    drink_grip: ['Laser engraving', 'Not sure'],
    drink_handle: ['Laser engraving', 'Not sure'],
    glass: ['Sandblasting', 'Not sure'],
    collared: ['Embroidery', 'Not sure'],
    apparel: ['DTF print', 'Not sure'],
    hat: ['Embroidery', 'Leatherette patch', 'Not sure'],
    journal: ['Full-color UV', 'Not sure'],
    other: ['Laser engraving', 'Sandblasting', 'Full-color UV', 'DTF print', 'Not sure'],
    any: ALL_METHODS
  };
  var CLASS_NOTE = {
    drink_nouv: 'Laser engraving only on this item (no full-color UV).',
    drink_grip: 'Silicone-grip tumbler: laser engraving only (no full-color UV).',
    drink_handle: 'Handled tumbler/mug: laser engraving only (no full-color UV).',
    glass: 'Glassware: sandblasting only (no full-color UV).',
    collared: 'Polos, collared shirts, zips and jackets: embroidery.',
    apparel: 'T-shirts, hoodies and crews: DTF print.',
    hat: 'Hats: embroidery or leatherette patch.'
  };
  /* Customizer line property "Decoration Method" -> dropdown label */
  var METHOD_ALIASES = {
    'laser engraving': 'Laser engraving',
    'laser': 'Laser engraving',
    'sandblasting': 'Sandblasting',
    'full color (uv)': 'Full-color UV',
    'uv': 'Full-color UV',
    'embroidery': 'Embroidery',
    'dtf': 'DTF print',
    'leatherette patch': 'Leatherette patch'
  };
  /* Line properties shown as their own labeled fields (others go to "Details"). */
  var KNOWN_PROPS = ['Decoration Method', 'Logo - Front', 'Mockup', 'Text - Front', 'Notes'];

  var serverClasses = null;
  var itemChoices = {}; /* line key -> chosen method (survives re-render) */

  function readServerClasses() {
    if (serverClasses) return serverClasses;
    serverClasses = {};
    var el = document.querySelector('[data-quote-item-classes]');
    if (el) {
      try { serverClasses = JSON.parse(el.textContent || '{}') || {}; } catch (e) { serverClasses = {}; }
    }
    return serverClasses;
  }

  function lc(s) { return String(s || '').toLowerCase(); }

  /* Fallback when the product is not in the Liquid map (cart changed after page load). */
  function classifyItem(item) {
    var map = readServerClasses();
    if (map[String(item.product_id)]) return map[String(item.product_id)];
    var t = lc(item.product_type), h = lc(item.handle), ti = lc(item.product_title), sku = lc(item.sku);
    if (t.indexOf('addon') !== -1 || t.indexOf('add-on') !== -1) return 'addon';
    if (t === 'hats' || t === 'hat') return 'hat';
    if (t.indexOf('journal') !== -1) return 'journal';
    if (t === 'apparel') {
      return (ti.indexOf('polo') !== -1 || h.indexOf('polo') !== -1 || ti.indexOf('collar') !== -1 || sku.indexOf('k500') !== -1) ? 'collared' : 'apparel';
    }
    if (t.indexOf('glassware') !== -1) return 'glass';
    if (t.indexOf('drinkware') !== -1) {
      if (/pcg|dg|dcs|lg5|dc3|dc4/.test(sku)) return 'glass';
      if (h.indexOf('silicone-grip') !== -1 || ti.indexOf('silicone grip') !== -1) return 'drink_grip';
      if (h.indexOf('without-handle') !== -1 || ti.indexOf('without handle') !== -1) return 'drink';
      if (/mug|sippy/.test(h) || /mug|handle/.test(ti)) return 'drink_handle';
      return 'drink';
    }
    return 'other';
  }

  function normalizeMethod(v) {
    var k = lc(v).trim();
    return METHOD_ALIASES[k] || '';
  }

  function isUrl(v) { return /^https?:\/\//i.test(String(v || '')) || /^\/\//.test(String(v || '')); }
  function absUrl(v) {
    v = String(v || '');
    if (/^\/\//.test(v)) return 'https:' + v;
    if (/^\//.test(v)) return (window.location.origin || '') + v;
    return v;
  }

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (text != null) n.textContent = text;
    return n;
  }

  function hidden(name, value) {
    return el('input', { type: 'hidden', name: 'contact[' + name + ']', value: String(value) });
  }

  function fillSelect(select, allowed, preferred) {
    var current = preferred || select.value;
    select.textContent = '';
    allowed.forEach(function (m) {
      var o = el('option', { value: m }, m);
      select.appendChild(o);
    });
    select.value = allowed.indexOf(current) !== -1 ? current : 'Not sure';
  }

  /* Build a structured item model from a /cart.js line. */
  function itemModel(item, index) {
    var props = item.properties || {};
    var details = [];
    Object.keys(props).forEach(function (key) {
      if (!key || key.charAt(0) === '_') return;
      if (KNOWN_PROPS.indexOf(key) !== -1) return;
      var val = props[key];
      if (val == null || val === '') return;
      if (key === 'Logo - Back' && val === 'Same as front') return;
      if (key === 'Text rotation' && String(val) === '0') return;
      if (/box %$/.test(key)) return;
      details.push(key + ': ' + (isUrl(val) ? absUrl(val) : val));
    });
    var cls = classifyItem(item);
    var allowed = METHODS_BY_CLASS[cls] || METHODS_BY_CLASS.other;
    var fromCart = normalizeMethod(props['Decoration Method']);
    var chosen = itemChoices[item.key] || (allowed.indexOf(fromCart) !== -1 ? fromCart : '') || (allowed.length === 2 ? allowed[0] : 'Not sure');
    return {
      n: index + 1,
      key: item.key,
      cls: cls,
      allowed: allowed,
      title: item.product_title || item.title || 'Item',
      variant: item.variant_title || '',
      sku: item.sku || '',
      qty: item.quantity,
      method: cls === 'addon' ? '' : chosen,
      logo: props['Logo - Front'] ? absUrl(props['Logo - Front']) : '',
      mockup: props['Mockup'] ? absUrl(props['Mockup']) : '',
      text: props['Text - Front'] || '',
      itemNotes: props['Notes'] || '',
      details: details.join('; '),
      url: item.url ? absUrl(item.url) : ''
    };
  }

  function renderItems(form, models) {
    var box = form.querySelector('[data-quote-items]');
    if (!box) return;
    box.textContent = '';
    if (!models.length) { box.hidden = true; return; }
    box.hidden = false;
    box.appendChild(el('p', { class: 'sancando-request-quote__items-title' }, 'Items in your quote (' + models.length + ')'));
    models.forEach(function (m) {
      var wrap = el('div', { class: 'sancando-request-quote__item', 'data-quote-item': m.key });
      wrap.appendChild(el('p', { class: 'sancando-request-quote__item-name' }, m.n + '. ' + m.title + (m.variant ? ' — ' + m.variant : '')));
      wrap.appendChild(el('p', { class: 'sancando-request-quote__item-meta' }, 'Qty ' + m.qty + (m.logo ? ' · logo attached' : '') + (m.mockup ? ' · mockup attached' : '')));
      if (m.cls !== 'addon') {
        var id = 'QuoteItemMethod' + m.n;
        var field = el('div', { class: 'sancando-request-quote__field' });
        field.appendChild(el('label', { for: id }, 'Decoration method'));
        var sel = el('select', { id: id, name: 'contact[Item ' + m.n + ' - Decoration method]', 'data-quote-item-method': m.key });
        fillSelect(sel, m.allowed, m.method);
        sel.addEventListener('change', function () {
          itemChoices[m.key] = sel.value;
          m.method = sel.value;
          writeSummary(form, lastModels);
        });
        field.appendChild(sel);
        wrap.appendChild(field);
        if (CLASS_NOTE[m.cls]) wrap.appendChild(el('p', { class: 'sancando-request-quote__hint' }, CLASS_NOTE[m.cls]));
      }
      /* Labeled per-line fields for the email (one item at a time). */
      wrap.appendChild(hidden('Item ' + m.n + ' - Product', m.title + (m.sku ? ' (SKU ' + m.sku + ')' : '')));
      if (m.variant) wrap.appendChild(hidden('Item ' + m.n + ' - Color/variant', m.variant));
      wrap.appendChild(hidden('Item ' + m.n + ' - Qty', m.qty));
      if (m.logo) wrap.appendChild(hidden('Item ' + m.n + ' - Logo', m.logo));
      if (m.mockup) wrap.appendChild(hidden('Item ' + m.n + ' - Mockup', m.mockup));
      if (m.text) wrap.appendChild(hidden('Item ' + m.n + ' - Text', m.text));
      if (m.itemNotes) wrap.appendChild(hidden('Item ' + m.n + ' - Item notes', m.itemNotes));
      if (m.details) wrap.appendChild(hidden('Item ' + m.n + ' - Details', m.details));
      if (m.url) wrap.appendChild(hidden('Item ' + m.n + ' - Link', m.url));
      box.appendChild(wrap);
    });
  }

  function summaryText(models) {
    if (!models.length) return 'Quote request (no cart items). See the fields above.';
    var lines = ['Quote request: ' + models.length + ' item(s). Full details per item are in the Item fields.', ''];
    models.forEach(function (m) {
      lines.push(m.n + ') ' + m.title + (m.variant ? ' — ' + m.variant : '') + ' | Qty ' + m.qty + (m.method ? ' | ' + m.method : ''));
    });
    return lines.join('\n');
  }

  function writeSummary(form, models) {
    var ta = form.querySelector('[data-quote-message]');
    var text = summaryText(models);
    if (ta) ta.value = text;
    var a = form.querySelector('[data-quote-mailto]');
    if (a) {
      var mailLines = [text, ''];
      models.forEach(function (m) {
        if (m.logo) mailLines.push('Item ' + m.n + ' logo: ' + m.logo);
        if (m.mockup) mailLines.push('Item ' + m.n + ' mockup: ' + m.mockup);
      });
      a.href = 'mailto:sandi@sancandoswag.com?subject=' + encodeURIComponent('Quote request — SanCanDo Swag') + '&body=' + encodeURIComponent(mailLines.join('\n'));
    }
  }

  var lastModels = [];
  function sentKeys() { return JSON.stringify(lastModels.map(function (m) { return m.key; })); }

  /* 2026-10-07: fee lines follow their parent line (see header). */
  function isFeeLine(item) { var p = (item && item.properties) || {}; return p._addon != null && String(p._addon) !== ''; }
  function parentLine(item, items) {
    var p = item.properties || {};
    var pid = String(p._parent == null ? '' : p._parent);
    var forTitle = String(p.For == null ? '' : p.For);
    var hit = null;
    if (pid) hit = items.filter(function (it) { return !isFeeLine(it) && String(it.product_id) === pid; })[0] || null;
    if (!hit && forTitle) hit = items.filter(function (it) { return !isFeeLine(it) && String(it.product_title || '') === forTitle; })[0] || null;
    return hit;
  }
  function classifyLine(item, items) {
    if (isFeeLine(item)) {
      var parent = parentLine(item, items || []);
      if (parent && classifyItem(parent) === PUBLIC_CLASS) return PUBLIC_CLASS;
    }
    return classifyItem(item);
  }

  function isQuoteLine(item, items) { return classifyLine(item, items) !== PUBLIC_CLASS; }

  /* 2026-10-07 stale-map fix: re-read the per-product class map from the cart section when the cart has a product
     the page's map does not know (added after page load). One request, only when needed; on failure keep today's fallback. */
  function refreshClasses(cart) {
    var items = (cart && cart.items) || [];
    var map = readServerClasses();
    var stale = items.some(function (it) { return !Object.prototype.hasOwnProperty.call(map, String(it.product_id)); });
    if (!stale) return Promise.resolve(cart);
    /* No Accept: application/json here: on /cart that header returns cart JSON instead of the sections payload. */
    return fetch('/cart?sections=sancando-request-quote', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json['sancando-request-quote'];
        if (!html) return cart;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-quote-item-classes]');
        if (!node) return cart;
        var fresh = JSON.parse(node.textContent || '{}') || {};
        Object.keys(fresh).forEach(function (k) { serverClasses[k] = fresh[k]; });
        return cart;
      })
      .catch(function () { return cart; });
  }

  function applyModels(form, cart) {
    var all = (cart && cart.items) || [];
    var items = all.filter(function (it) { return isQuoteLine(it, all); });
    lastModels = items.map(itemModel);
    renderItems(form, lastModels);
    writeSummary(form, lastModels);
    var landing = form.closest('[data-quote-mode="landing"]');
    var globalMethod = form.querySelector('[data-quote-global-method]');
    var globalSelect = form.querySelector('[data-quote-method-select]');
    var products = form.querySelector('[data-quote-products]');
    if (!landing && globalMethod && globalSelect) {
      /* Cart mode: per-item selects replace the global one when items exist. */
      var hasItems = lastModels.length > 0;
      globalMethod.hidden = hasItems;
      globalSelect.disabled = hasItems;
      var lockNote = form.querySelector('[data-quote-lock-note]');
      if (lockNote) lockNote.hidden = hasItems;
    }
    if (landing && products) {
      /* Landing: products-of-interest required only when the cart is empty. */
      products.required = lastModels.length === 0;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(refreshClasses);
  }

  function loadCartAndFill(form) {
    return fetchCart()
      .then(function (cart) { applyModels(form, cart); return cart; })
      .catch(function () {
        var ta = form.querySelector('[data-quote-message]');
        if (ta) ta.value = 'Quote request: could not load the cart, please list items in Notes.';
      });
  }

  /* Landing page: filter the global decoration dropdown by chosen product type. */
  function bindProductType(form) {
    var type = form.querySelector('[data-quote-product-type]');
    var select = form.querySelector('[data-quote-method-select]');
    if (!type || !select) return;
    function sync() {
      var opt = type.options[type.selectedIndex];
      var cls = (opt && opt.getAttribute('data-cls')) || 'other';
      fillSelect(select, cls === 'other' ? METHODS_BY_CLASS.any : METHODS_BY_CLASS[cls] || METHODS_BY_CLASS.any);
    }
    type.addEventListener('change', sync);
    sync();
  }

  function captureSource(form) {
    var src = form.querySelector('[data-quote-source]');
    if (!src) return;
    try {
      var p = new URLSearchParams(window.location.search);
      var bits = [];
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (p.get(k)) bits.push(k.replace('utm_', '') + '=' + p.get(k)); });
      if (!bits.length && document.referrer && document.referrer.indexOf(window.location.host) === -1) bits.push('referrer=' + document.referrer.split('?')[0]);
      if (bits.length) src.value = src.value + ' (' + bits.join(', ') + ')';
    } catch (e) {}
  }

  /* Remove only the quote lines that were sent (keys saved before submit). Legacy '1': every non-public line.
     Resolves to the number of lines removed and whether public-price lines remain. */
  function removeQuoteLines(saved) {
    var keys = null;
    try { var v = JSON.parse(saved); if (Array.isArray(v)) keys = v; } catch (e) {}
    return fetchCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var updates = {};
      var n = 0;
      items.forEach(function (it) {
        var hit = keys ? keys.indexOf(it.key) !== -1 : isQuoteLine(it, items);
        if (hit && isQuoteLine(it, items)) { updates[it.key] = 0; n++; }
      });
      var left = items.filter(function (it) { return !updates.hasOwnProperty(it.key) && !isQuoteLine(it, items); }).length; /* public (buy-lane) lines left */
      if (!n) return { removed: 0, left: left };
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return { removed: n, left: left }; });
    }).catch(function () { return { removed: 0, left: 0 }; });
  }

  function afterRemove(res) {
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    /* Journals left in the cart: reload once so the cart shows the Checkout lane (storage is already cleared, no loop). */
    if (res && res.removed && res.left > 0 && /^\/cart\/?$/.test(window.location.pathname)) {
      window.location.replace('/cart?quote_sent=1');
    }
  }

  function showQuoteSent() {
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (p.get('quote_sent') !== '1' || document.querySelector('[data-quote-sent]')) return;
    var msg = el('p', { class: 'sancando-quote-sent', 'data-quote-sent': '1', role: 'status' },
      'Thanks! Your quote request was sent. Your items are still in your cart, ready to check out.');
    var main = document.querySelector('main') || document.body;
    main.insertBefore(msg, main.firstChild);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    showQuoteSent();
    /* Remove the sent quote lines only once the quote really went through (success message on the page).
       A page showing the form's error message drops the pending keys without touching the cart. */
    var saved = sessionStorage.getItem(STORAGE_CLEAR);
    if (document.querySelector('[data-quote-success]')) {
      /* Keys saved: remove only those quote lines. No keys (storage blocked/lost, new tab): remove ALL quote lines
         ('1' = every non-journal_public line), matching live's always-clear on the success page. Journals stay. */
      sessionStorage.removeItem(STORAGE_CLEAR);
      removeQuoteLines(saved || '1').then(afterRemove);
    } else if (saved && document.querySelector('.sancando-request-quote__error')) {
      sessionStorage.removeItem(STORAGE_CLEAR);
    }

    var form = document.getElementById('sancando-quote-contact-form');
    if (form && document.querySelector('[data-sancando-request-quote]')) {
      bindProductType(form);
      prefillRestock(form);
      captureSource(form);
      loadCartAndFill(form);

      /* 2026-10-07 pack2 (#167 only, not ported): the server leaves the form out for an empty cart. If the last line is
         removed on /cart without a reload, hide the form too (and show it again if lines come back). Cart mode only. */
      if (!form.closest('[data-quote-mode="landing"]')) {
        document.addEventListener('shopify:cart:lines-update', function (e) {
          /* The theme fires this event BEFORE its /cart/change request; e.promise settles when the change is done. */
          var done = (e && (e.promise || (e.detail && e.detail.promise))) || new Promise(function (r) { setTimeout(r, 1200); });
          Promise.resolve(done).catch(function () {}).then(fetchCart).then(function (cart) {
            var empty = !(cart && cart.item_count);
            var sec = document.querySelector('[data-sancando-request-quote]');
            var box = sec && (sec.closest('.shopify-section') || sec);
            if (box) box.style.display = empty ? 'none' : '';
            if (!empty) applyModels(form, cart);
          }).catch(function () {});
        });
      }

      /* #167 captcha fix: never cancel + re-submit natively. Native form.submit() fires no submit event, so
         Shopify's hCaptcha (storefront-forms captcha) never adds h-captcha-response -> "Missing CAPTCHA token".
         Keep the model fresh BEFORE submit instead (qty edits on /cart fire shopify:cart:lines-update, handled
         above; also refresh when the shopper enters the form), and let the submit event run untouched. */
      /* Once only: renderItems() rebuilds the per-item selects, so a refresh on every focus would wipe choices. */
      var primed = false;
      form.addEventListener('focusin', function () {
        if (primed) return;
        primed = true;
        fetchCart().then(function (cart) { applyModels(form, cart); }).catch(function () {});
      });
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented) return; /* required-field check blocked it */
        sessionStorage.setItem(STORAGE_CLEAR, sentKeys());
      });
    }

    /* Drawer CTA: block when disabled */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.sancando-request-quote-btn');
      if (btn && btn.getAttribute('aria-disabled') === 'true') e.preventDefault();
    }, true);
  });

  /* SanCanDo 2026-09-30: out-of-stock selection on a PDP (blocks/buy-buttons.liquid marks the button
     data-sancando-restock="true"). The cart refuses deny-policy variants at 0, so Add to Quote opens the
     quote form prefilled with the item instead of a cart add. Capture phase: runs before the theme's
     product-form and add-to-cart handlers. No prices are read or written. */
  var RESTOCK_URL = '/pages/contact?view=request-quote';
  function restockGo(form) {
    try {
      var picker = document.querySelector('main variant-picker') || document.querySelector('variant-picker');
      var title = (picker && picker.getAttribute('data-product-title')) || (document.querySelector('main h1') || {}).textContent || '';
      var opts = picker ? Array.prototype.map.call(picker.querySelectorAll('fieldset input:checked, select'), function (i) { return i.value; }).filter(Boolean) : [];
      var color = '';
      if (picker) {
        var ci = Array.prototype.find.call(picker.querySelectorAll('fieldset input:checked'), function (i) { return /colou?r/i.test(i.getAttribute('data-option-name') || ''); });
        if (ci) color = ci.value;
      }
      var qty = form && form.querySelector('input[name="quantity"]');
      var method = document.querySelector('input[name="properties[Decoration Method]"]:checked');
      var q = new URLSearchParams();
      q.set('restock', '1');
      q.set('product', String(title).trim().slice(0, 150));
      if (opts.length) q.set('options', opts.join(' / ').slice(0, 150));
      if (color) q.set('color', color.slice(0, 100));
      if (qty && qty.value) q.set('qty', String(qty.value).slice(0, 6));
      if (method && method.value) q.set('method', method.value.slice(0, 60));
      /* 2026-09-30: product-type class for the form's "Product type" select (add-to-cart-button.liquid). */
      var qt = (form && form.querySelector('[data-sancando-quote-type]')) || document.querySelector('main [data-sancando-quote-type]');
      if (qt && qt.getAttribute('data-sancando-quote-type')) q.set('ptype', qt.getAttribute('data-sancando-quote-type').slice(0, 20));
      var vid = form && form.querySelector('input[name="id"]');
      q.set('item_url', window.location.pathname + (vid && vid.value ? '?variant=' + vid.value : ''));
      window.location.href = RESTOCK_URL + '&' + q.toString();
    } catch (e) {
      window.location.href = RESTOCK_URL;
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[data-sancando-restock="true"]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    restockGo(btn.form || btn.closest('form'));
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('button[data-sancando-restock="true"]')) return;
    e.preventDefault();
    e.stopPropagation();
    restockGo(form);
  }, true);

  /* Landing form: prefill a restock request coming from a PDP (see restockGo). */
  function prefillRestock(form) {
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (p.get('restock') !== '1' || !form.closest('[data-quote-mode="landing"]')) return;
    function set(sel, val) { var el = form.querySelector(sel); if (el && val && !el.value) el.value = val; }
    var item = (p.get('product') || '') + (p.get('options') ? ' (' + p.get('options') + ')' : '');
    set('[data-quote-products]', item + ' - out of stock, ships once restocked');
    set('#QuoteColors', p.get('color'));
    set('#QuoteQty', p.get('qty'));
    set('#QuoteNotes', 'Restock request from the product page: ' + item + (p.get('item_url') ? '\n' + window.location.origin + p.get('item_url') : ''));
    /* 2026-09-30: Product type from the PDP class; unknown/other keeps the default "Not sure / several".
       Set before the method so bindProductType's change handler narrows the methods first. */
    var ptype = String(p.get('ptype') || '');
    if (ptype === 'drink_nouv') ptype = 'drink';
    var typeSel = form.querySelector('[data-quote-product-type]');
    if (typeSel && ptype && ptype !== 'other') {
      var hit = Array.prototype.find.call(typeSel.options, function (o) { return o.getAttribute('data-cls') === ptype; });
      if (hit && typeSel.value !== hit.value) {
        typeSel.value = hit.value;
        try { typeSel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    }
    var method = p.get('method');
    var sel = form.querySelector('[data-quote-method-select]');
    if (method && sel) {
      var want = METHOD_ALIASES[String(method).toLowerCase()] || method;
      Array.prototype.forEach.call(sel.options, function (o) { if (o.value === want) sel.value = want; });
    }
    var src = form.querySelector('[data-quote-source]');
    if (src) src.value = 'Restock request (product page)';
  }

  /* Jefe 2026-09-18: Name, Email, Phone mandatory (capture phase, runs before the submit hook above). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'sancando-quote-contact-form') return;
    var name = form.querySelector('#QuoteName');
    var email = form.querySelector('#QuoteEmail');
    var phone = form.querySelector('#QuotePhone');
    var missing = [];
    if (!name || !String(name.value || '').trim()) missing.push('Name');
    if (!email || !String(email.value || '').trim()) missing.push('Email');
    if (!phone || !String(phone.value || '').trim()) missing.push('Phone');
    if (missing.length) {
      e.preventDefault();
      alert('Please fill in: ' + missing.join(', '));
      (missing[0] === 'Name' ? name : missing[0] === 'Email' ? email : phone).focus();
    }
  }, true);
})();
